import { render, staticRenderFns } from "./WorkLoadResult.vue?vue&type=template&id=b827e03c&scoped=true&"
import script from "./WorkLoadResult.vue?vue&type=script&lang=js&"
export * from "./WorkLoadResult.vue?vue&type=script&lang=js&"
import style0 from "./WorkLoadResult.vue?vue&type=style&index=0&id=b827e03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b827e03c",
  null
  
)

export default component.exports